export const app = {
  'app.name': 'Marginalia',
  'app.tagline': 'Beasts in the margins',
  'app.screen.boot': 'Opening the book',
  'app.screen.title': 'Title',
  'app.screen.settings': 'Settings',
  'app.boot.loading': 'The scribe is mixing colours…',
  'app.boot.noscript': 'Marginalia needs JavaScript enabled.',
  'app.boot.line.1': 'Grinding lapis lazuli…',
  'app.boot.line.2': 'Sharpening quills…',
  'app.boot.line.3': 'Gilding the halos…',
  'app.boot.line.4': 'Chasing mice off the parchment…',
  'app.boot.line.5': 'Mixing vermilion…',
  'app.boot.line.6': 'Ruling the margins…',
  'app.boot.line.7': 'Waking Brother Scribe…',
  'app.boot.line.8': 'Drying ink by candlelight…',
  'app.boot.line.9': 'Counting cats in the margins…',
  'app.boot.line.10': 'Dusting the binding…',
  'app.boot.line.11': 'Looking for the missing brush…',
  'app.boot.line.12': 'Negotiating a feather with the goose…',
  'app.boot.slow': 'Still copying — old abbey, unhurried monks.',
  'app.boot.progress': '{p}%',
  'app.lite.name': 'Simplified graphics',
  'app.lite.banner.noApi': 'Every adventure is available without WebGPU.',
  'app.lite.banner.insecure': '3D battle scenes need HTTPS. You can keep playing.',
  'app.lite.banner.noAdapter': '3D scenes are resting. Every adventure is available.',
  'app.lite.banner.lost': 'The paints spilled. Continuing with illustrated battles.',
  'app.lite.more': 'Details ›',
  'app.lite.close': 'Hide',
  'app.lite.sheet.body': 'WebGPU draws 3D battle scenes. Without it, battles use illustrated figures. The creator, adventures, cards, races and saves work as usual.',
  'app.lite.sheet.where': 'To enable 3D battle scenes:',
  'app.lite.sheet.b1': 'Use an up-to-date Chrome or Edge',
  'app.lite.sheet.b2': 'Safari 26 or newer',
  'app.lite.sheet.b3': 'Firefox on Windows',
  'app.lite.sheet.b4': 'Enable hardware acceleration',
  'app.lite.code': 'Code: {code}',
  'app.lite.retry': 'Try again',
  'app.lite.retry.busy': 'Trying…',
  'app.lite.retry.fail': 'The colours still refuse to settle.',
  'app.lite.retry.ok': 'Success! The miniatures return on the next page.',
  'app.lite.ok': 'Understood',
  'app.gpu.lost': 'Spilled ink — repainting…',
  'app.gpu.lost.failed': 'The miniatures have not dried.',
  'app.gpu.restart': 'Restart',
  'app.gpu.lite': 'Simplified graphics',
  'app.save.readonly.title': 'This copy is newer than its scribe',
  'app.save.readonly.body': 'Your save came from a newer edition. Reload the page to keep it safe.',
  'app.save.copied': 'Save copied to the clipboard. Keep it away from mice.',
  'app.save.import.title': 'Import a save', 'app.save.import.code': 'Save code',
  'app.save.import.hint': 'Paste the code from an exported save. The scribe will check it before importing.',
  'app.save.import.check': 'Check this copy', 'app.save.import.invalid': 'This copy is damaged or needs another edition of the game. Your current progress is unchanged.',
  'app.save.import.confirm': 'Replace your current chronicle?',
  'app.save.import.replace': 'This copy replaces your hero and all their deeds on this device. Export your current chronicle first if you want to keep it.',
  'app.save.import.done': 'Chronicle imported.',
  'app.diag.copied': 'Diagnostics copied.',
  'app.clipboard.failed': 'The clipboard eluded the scribe.',
  'app.save.full': 'The book is full: your latest progress could not be saved.',
  'app.save.restored': 'The latest page was damaged. An earlier copy has been restored.',
  'app.lock.title': 'Open in another tab',
  'app.lock.body': 'Your chronicle is open elsewhere. Two scribes on one page make a mess.',
  'app.lock.take': 'Play here',
  'app.fatal.title': 'The chronicle would not open',
  'app.fatal.body': 'Something prevented the book from opening. Reload, or copy diagnostics for the scribe.',
  'app.fatal.reload': 'Reload',
  'app.fatal.copy': 'Copy diagnostics',
  'app.fatal.copied': 'Copied',
  'app.error.screen.title': 'This chapter would not open',
  'app.error.screen.body': 'The scribe stumbled on this page. Go back; the rest of the book is safe.',
  'app.nav.back': 'Back',
  'app.title.subtitle': 'beasts from the margins of an old book',
  'app.title.start': 'Begin your chronicle',
  'app.title.continue': 'Continue your chronicle',
  'app.title.poke': 'Poke the beast',
} as const;
